import * as _ from 'underscore';
import { DataMap } from './dataMap';
import { SortOptions, SortingDataMapOptions, PreSortingOptions } from '../../interfaces/options';
import { Util } from '..';
import { SortState } from '../../enums';

export class SortingDataMap<T> extends DataMap<T> {
	private sortSettings: KnockoutObservableArray<SortOptions>;
	constructor(
		data: KnockoutObservableArray<T> | KnockoutComputed<T[]> | KnockoutObservable<T[]> | DataMap<T>,
		options: SortingDataMapOptions<T>
	) {
		super(data);
		options = $.extend(
			true,
			<SortingDataMapOptions<T>>{
				preSorting: []
			},
			options || {}
		);
		this.sortSettings = ko.observableArray<SortOptions>();
		this.map = ko.pureComputed(() => {
			var sortSettings = this.sortSettings(),
				items = this.data();
			if (options.preSorting && options.preSorting.length > 0 && items) {
				Util.reverseClonedArray(options.preSorting).forEach((preSorting: PreSortingOptions<T>) => {
					let state = preSorting.state;
					if (state != SortState.NONE) {
						items = _.sortBy(items, item =>
							preSorting.fn(ko.utils.unwrapObservable(Util.getProperty(item, preSorting.key)), item)
						);
						if (state === SortState.DESC) {
							items.reverse();
						}
					}
				});
			}
			if (sortSettings && sortSettings.length > 0 && items) {
				Util.reverseClonedArray(sortSettings).forEach(
					(sortSetting: SortOptions, index: number, reversedSettings: SortOptions[]) => {
						let state = sortSetting.state;
						if (state != SortState.NONE) {
							items = _.sortBy(items, item =>
								ko.utils.unwrapObservable(Util.getProperty(item, sortSetting.key))
							);
							if (state === SortState.DESC) {
								items.reverse();
							}
						}
						if (
							reversedSettings[index + 1] &&
							reversedSettings[index + 1].state === SortState.DESC
						) {
							items.reverse();
						}
					}
				);
				return items;
			} else {
				return items;
			}
		});
	}
	public sort(settings: SortOptions[]) {
		this.sortSettings(settings);
	}
}
